export default function PHP_Syntax() {
  return (
    <div>
      <h1>PHP_Syntax</h1>
    </div>
  );
}
